import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdDashboard, MdLightbulb, MdSettings, MdExitToApp } from 'react-icons/md';
import { PiFan } from 'react-icons/pi';
import { FaWater } from "react-icons/fa";
import useAuth from '../../hooks/useAuth';
import useActiveCondominio from '../../hooks/useActiveCondominio';
import { useFeatures } from '../../hooks/useFeatures';
import '../../App.css';
import './SideMenu.css';

const SideMenu = ({ isCollapsed, onNavigate }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { activeCondominio, condominios } = useActiveCondominio();
  const { loading: featuresLoading, hasAccessToFeature, hasCategoryAccess } = useFeatures();

  const currentCondominioName = activeCondominio && condominios
    ? condominios.find(c => c.id && String(c.id) === String(activeCondominio))?.nome || 'Automa'
    : 'Automa';

  const isDashboardEnabled    = !featuresLoading && hasAccessToFeature('dashboard');
  const isExaustoresEnabled    = !featuresLoading && hasAccessToFeature('exaustores');
  const isReservatoriosEnabled = !featuresLoading && hasAccessToFeature('reservatorios');
  const hasConfigAccess        = !featuresLoading && hasCategoryAccess('configuracao');

  const handleLogout = () => {
    logout();
    navigate("/login");
    onNavigate?.();
  };

  const handleNavigate = () => {
    onNavigate?.();
  };

  return (
    <div className={`side-menu ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="menu-logo-container">
        <h2 className="menu-logo-text">{currentCondominioName}</h2>
      </div>
      <div className="menu-header-border"></div>
      <nav>
        {isDashboardEnabled && (
          <Link to="/home" className={location.pathname === '/home' ? 'active' : ''} onClick={handleNavigate}>
            <span className="menu-icon"><MdDashboard /></span>
            <span className="menu-text">Dashboard</span>
          </Link>
        )}
        {isExaustoresEnabled && (
          <Link to="/exaustao" className={location.pathname === '/exaustao' ? 'active' : ''} onClick={handleNavigate}>
            <span className="menu-icon"><span className="fan-icon-badge fan-icon-badge--menu"><PiFan /></span></span>
            <span className="menu-text">Exaustores</span>
          </Link>
        )}
        {isReservatoriosEnabled && (
          <Link to="/reservatorios" className={location.pathname === '/reservatorios' ? 'active' : ''} onClick={handleNavigate}>
            <span className="menu-icon"><FaWater /></span>
            <span className="menu-text">Reservatórios</span>
          </Link>
        )}
        <Link to="#" className="disabled">
          <span className="menu-icon"><MdLightbulb /></span>
          <span className="menu-text">Iluminação</span>
        </Link>

      </nav>
      <div className="menu-footer">
        {hasConfigAccess && (
          <Link
            to="/configuracoes"
            className={location.pathname.startsWith('/configuracoes') ? 'active' : ''}
            onClick={handleNavigate}
          >
            <span className="menu-icon"><MdSettings /></span>
            <span className="menu-text">Configurações</span>
          </Link>
        )}
        <button className="logout-button" onClick={handleLogout}>
          <span className="menu-icon"><MdExitToApp /></span>
          <span className="menu-text">Sair</span>
        </button>
      </div>
    </div>
  );
};

export default SideMenu;
